import my from '@/pages/my'
const changePassword = () => import('@/pages/changePassword')
const searchOrder = () => import('@/pages/searchOrder')
const searchOrderIndex = () => import('@/pages/common/searchOrderIndex')
const allSearch = () => import('@/pages/allSearch')
const repairDetailFlow = () => import('@/components/commonPage/repairDetailFlow')
const decode = () => import('@/pages/decode')
const mapPage = () => import('@/pages/mapPage')
const privacyStatement = () => import('@/pages/privacyStatement')
const registrationAgreement = () => import('@/pages/registrationAgreement')
const evaluate = () => import('@/pages/evaluate')
const questionnaire = () => import('@/pages/questionnaire')
const signPage = () => import('@/pages/signPage')
export default [
  {
    path: '/repairDetailFlow',
    name: 'RepairDetailFlow',
    component: repairDetailFlow,
    meta: {
      cache: true
    }
  },

  {
    path: '/decode',
    name: 'decode',
    component: decode,
    meta: {}
  },

  {
    path: '/allSearch',
    name: 'allSearch',
    component: allSearch,
    meta: {}
  },

  {
    path: '/mapPage',
    name: 'mapPage',
    component: mapPage,
    meta: {
      noCache: true
    }
  },

  {
    path: '/searchOrder',
    name: 'searchOrder',
    component: searchOrder,
    meta: {}
  },
  {
    path: '/searchOrderIndex',
    name: 'searchOrderIndex',
    component: searchOrderIndex,
    meta: {}
  },
  {
    path: '/my',
    name: 'my',
    component: my,
    meta: {}
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: changePassword,
    meta: {}
  },

  {
    path: '/r',
    name: 'evaluate',
    component: evaluate,
    meta: {}
  },
  {
    path: '/q',
    name: 'questionnaire',
    component: questionnaire,
    meta: {}
  },

  {
    path: '/privacyStatement',
    name: 'privacyStatement',
    component: privacyStatement,
    meta: {}
  },
  {
    path: '/registrationAgreement',
    name: 'registrationAgreement',
    component: registrationAgreement,
    meta: {}
  },
  {
    path: '/signPage',
    name: 'signPage',
    component: signPage,
    meta: {}
  },
  { // 隐私号页面
    path: '/privacyNumber',
    name: 'PrivacyNumber',
    component: () => import('@/pages/privacyNumber/index.vue'),
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/commonPage/index.js